module.exports = __webpack_public_path__ + "img/ski1.bad585bc.png";